/*
 * dän v3.9 cake page: pickup store + day, quantity, add to bag.
 * The rules are the cart's (assets/dan-cart.js) and BakeOps' (apps/api/src/modules/shopify/rules.ts), read from
 * window.DAN_ORDERING: a whole cake may be ordered for tomorrow until cakeCutoff (10 PM), otherwise the day after;
 * today only when the store is open long enough and its case shows enough cakes (≤ sameDayMaxPerItem each).
 * This page only offers days; the bag picks the time, writes the order attributes and sets the pickup location.
 * Hand-off to the bag: localStorage danStore (via danSetStore) and danPickupDay, the keys dan-cart.js reads.
 * Ordering ahead: "Pick any date" takes any open day up to maxDaysAhead (90) out; it joins the chips, selected.
 */
(function () {
  var root = document.querySelector('[data-d9-pdp]');
  var form = root && root.querySelector('[data-d9-form]');
  if (!form) return;

  var R = window.DAN_ORDERING || {};
  var AV = 'https://bakeops-production.up.railway.app/api/public/availability';
  var CAP = +R.sameDayMaxPerItem || +root.getAttribute('data-cap') || 6;
  var LEAD = (+R.sameDayLeadMinutes || 30) / 60, STEP = (+R.slotMinutes || 15) / 60;
  var WHOLE_CAKE = /^CKE-.+-WHL(8)?(PS)?$/;
  var DAYS_SHOWN = 6, AHEAD = +R.maxDaysAhead || 90;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var daysEl = $('[data-d9-days]'), hint = $('[data-d9-day-hint]'), msg = $('[data-d9-msg]'), add = $('[data-d9-add]');
  var qtyN = $('[data-d9-qty-n]'), MSG0 = msg.textContent, later = $('[data-d9-later]'), laterErr = $('[data-d9-later-err]');
  var state = { qty: 1, day: null, chosen: false, later: null }; /* chosen: the customer picked the day themselves; later: from the date field */
  var stock = {}; /* "store|date|sku" -> {available:number|null} | 'pending' */

  function hOf(x, d) { var p = String(x || d).split(':'); return +p[0] + (+p[1] || 0) / 60; }
  function clock(h) { var H = Math.floor(h + 1e-9), m = Math.round((h - H) * 60); return (H % 12 || 12) + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ' ' + (H >= 12 ? 'PM' : 'AM'); }
  function money(c) { var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  function track(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }
  function nowNY() {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: (+p.hour % 24) + (+p.minute) / 60 };
  }
  function day(k) {
    var n = nowNY(), dt = new Date(Date.UTC(n.y, n.m - 1, n.d + k));
    return {
      k: k, iso: dt.toISOString().slice(0, 10), dow: dt.getUTCDay(),
      top: k === 0 ? 'Today' : k === 1 ? 'Tomorrow' : dt.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' }),
      sub: dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })
    };
  }

  function kOf(iso) { var n = nowNY(); return Math.round((Date.parse(iso + 'T00:00:00Z') - Date.UTC(n.y, n.m - 1, n.d)) / 864e5); }
  function firstK() { return nowNY().h >= cutoff() ? 2 : 1; }

  function variant() { var el = form.querySelector('input[name="variant"]:checked') || form.querySelector('input[name="variant"][type="hidden"]'); return el ? { id: +el.value, sku: el.getAttribute('data-sku') || '', price: +el.getAttribute('data-price') } : null; }
  function store() { try { var k = localStorage.getItem('danStore'); return window.DAN_STORES && window.DAN_STORES[k] ? k : null; } catch (e) { return null; } }
  function hoursOn(k, d) { var s = window.DAN_STORES && window.DAN_STORES[k]; if (!s || !s.hours) return [7, 20]; var h = s.hours[d.dow]; return !h || (s.closedDates || []).indexOf(d.iso) > -1 ? null : h; }
  function cutoff() { var v = variant(); return v && WHOLE_CAKE.test(v.sku) ? hOf(R.cakeCutoff, '22:00') : hOf(R.pickupCutoff, '18:00'); }
  function openLongEnoughToday(k) { var h = hoursOn(k, day(0)); return !!h && Math.ceil((nowNY().h + LEAD) / STEP - 1e-9) * STEP <= h[1] - STEP + 1e-9; }

  /* Stock from BakeOps: {available} when the shop's count is known, null when it is not. */
  function key(k, d, sku) { return k + '|' + d + '|' + sku; }
  function check(k, d) {
    var v = variant(), id = key(k, d, v.sku);
    if (!v.sku) { stock[id] = { available: null }; return Promise.resolve(); }
    if (stock[id]) return Promise.resolve();
    stock[id] = 'pending';
    var timeout = new Promise(function (_, no) { setTimeout(function () { no(new Error('timeout')); }, 4000); });
    return Promise.race([fetch(AV + '?store=' + k + '&date=' + d + '&skus=' + encodeURIComponent(v.sku)).then(function (r) { return r.ok ? r.json() : null; }), timeout])
      .then(function (j) { var it = j && j.items && j.items[v.sku]; stock[id] = { available: it && it.status === 'ok' && it.available != null ? it.available : null }; })
      .catch(function () { stock[id] = { available: null }; })
      .then(render);
  }
  function stockFor(k, d) { var s = stock[key(k, d, variant().sku)]; return s === 'pending' || !s ? undefined : s.available; }

  /* The days on offer, as the bag will offer them for a cakes-only order. */
  function days(k) {
    var out = [], d0 = day(0);
    if (k && openLongEnoughToday(k)) {
      var a = stockFor(k, d0.iso), ok = a != null && a >= state.qty && state.qty <= CAP;
      out.push({ d: d0, ok: ok, why: a === undefined ? 'Checking the case…' : a == null ? 'Call to check' : state.qty > CAP ? 'Up to ' + CAP + ' today' : a < state.qty ? (a > 0 ? 'Only ' + a + ' left' : 'Sold out') : 'In the case' });
    }
    for (var i = firstK(); i < 21 && out.length < DAYS_SHOWN; i++) {
      var d = day(i);
      if (k && !hoursOn(k, d)) continue;
      out.push({ d: d, ok: true, why: d.sub });
    }
    /* The date picked further ahead joins the chips, after the last one. */
    var kl = state.later ? kOf(state.later) : -1, last = out.length ? out[out.length - 1].d.k : 0;
    if (kl > last && kl >= firstK() && kl <= AHEAD) { var dl = day(kl); if (!k || hoursOn(k, dl)) out.push({ d: dl, ok: true, why: dl.sub }); }
    return out;
  }

  function render() {
    var k = store(), v = variant(), list = days(k);
    $$('input[name="store"]').forEach(function (r) { r.checked = r.value === k; });
    if (!state.chosen || !list.some(function (x) { return x.ok && x.d.iso === state.day; })) {
      var first = list.filter(function (x) { return x.ok; })[0];
      state.day = first ? first.d.iso : null;
    }
    daysEl.innerHTML = list.map(function (x) {
      return '<label class="d9-day"><input type="radio" name="day" value="' + x.d.iso + '"' + (x.d.iso === state.day ? ' checked' : '') + (x.ok ? '' : ' disabled') + '><span><b>' + x.d.top + '</b><small>' + (x.d.k === 0 ? x.why : x.d.sub) + '</small></span></label>';
    }).join('');
    var s = k && window.DAN_STORES[k], left = k && state.day ? stockFor(k, state.day) : undefined;
    hint.textContent = !k ? 'Choose a store to see today’s case. Next-day pickup: order by ' + clock(cutoff()) + '.'
      : left != null && left < state.qty && state.day !== day(0).iso ? 'Only ' + left + ' left for that day at ' + s.short + '. Choose fewer, another day or another store.'
      : 'Order by ' + clock(cutoff()) + ' for pickup tomorrow. You’ll choose the time in your bag.';
    var total = money(v.price * state.qty);
    $('[data-d9-total]').textContent = total;
    $('[data-d9-price]').textContent = money(v.price);
    var bp = document.querySelector('[data-d9-bar-price]'); if (bp) bp.textContent = total;
    later.min = day(firstK()).iso; later.max = day(AHEAD).iso;
    if (document.activeElement !== later) later.value = state.day && state.day === state.later ? state.later : '';
    qtyN.textContent = state.qty;
    $$('[data-d9-qty]')[0].disabled = state.qty <= 1;
    if (k && state.day) check(k, state.day);
  }

  /* "Pick any date": an open day at the chosen dän, from the first allowed day to AHEAD days out. */
  function pickLater(iso) {
    var k = store(), n = iso ? kOf(iso) : NaN, why = '';
    if (!(n >= 0)) why = '';
    else if (n < firstK() || n > AHEAD) why = 'Choose a date from ' + day(firstK()).sub + ' to ' + day(AHEAD).sub + '.';
    else if (k && !hoursOn(k, day(n))) why = window.DAN_STORES[k].short + ' is closed that day. Choose another date or another dän.';
    else { state.later = iso; state.day = iso; state.chosen = true; track({ event: 'pickup_day_selection', dan_day: iso, dan_source: 'later' }); }
    laterErr.textContent = why; laterErr.hidden = !why;
  }

  function say(text, err) { msg.textContent = text; msg.classList.toggle('is-err', !!err); }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'store') {
      if (window.danSetStore) window.danSetStore(t.value); else { try { localStorage.setItem('danStore', t.value); } catch (x) {} }
      track({ event: 'fulfillment_selection', dan_store: t.value, dan_source: 'product' });
      say(MSG0); check(t.value, day(0).iso);
    }
    if (t.name === 'day') { state.day = t.value; state.chosen = true; laterErr.hidden = true; track({ event: 'pickup_day_selection', dan_day: t.value }); }
    if (t.name === 'variant') stock = {};
    if (t === later) pickLater(t.value);
    render();
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-d9-qty]'); if (!b) return;
    state.qty = Math.max(1, state.qty + +b.getAttribute('data-d9-qty')); render();
  });
  window.addEventListener('dan:store', function () { var k = store(); if (k) check(k, day(0).iso); render(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var k = store(), v = variant();
    if (!k) { say('Choose the dän you’ll pick up from.', true); var f = form.querySelector('input[name="store"]'); f && f.focus(); return; }
    if (!state.day) { say('Choose a pickup day.', true); return; }
    var left = stockFor(k, state.day);
    if (left != null && left < state.qty) { say(left > 0 ? 'Only ' + left + ' left for that day at ' + window.DAN_STORES[k].short + '.' : 'Sold out for that day at ' + window.DAN_STORES[k].short + '.', true); return; }
    if (!window.danCart) { say('Something went wrong. Please refresh the page and try again.', true); return; }
    try { localStorage.setItem('danPickupDay', state.day); } catch (x) {}
    add.setAttribute('aria-busy', 'true'); add.disabled = true; say('Adding to your bag…');
    window.danCart.add([{ id: v.id, quantity: state.qty }], { open: true, name: (window.DAN39_PRODUCT || {}).title }).then(function () {
      say('Added. Choose your pickup time in the bag, then check out.');
      track({ event: 'dan_add_to_bag', dan_store: k, dan_day: state.day, ecommerce: { currency: (window.DAN39_PRODUCT || {}).currency, value: v.price * state.qty / 100, items: [{ item_id: v.sku, item_name: (window.DAN39_PRODUCT || {}).title, price: v.price / 100, quantity: state.qty }] } });
    }).catch(function (err) {
      say((err && err.message) || 'Could not add to your bag. Please try again.', true);
    }).then(function () { add.removeAttribute('aria-busy'); add.disabled = false; });
  });

  /* Gallery: thumbnails on desktop, swipe with a counter on phones. */
  var track_ = $('[data-d9-track]'), idx = $('[data-d9-idx]');
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-d9-thumb]'); if (!t) return;
    var i = +t.getAttribute('data-d9-thumb');
    track_.scrollTo({ left: i * track_.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  track_ && track_.addEventListener('scroll', function () {
    var i = Math.round(track_.scrollLeft / Math.max(1, track_.clientWidth));
    if (idx) idx.textContent = i + 1;
    $$('[data-d9-thumb]').forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
  }, { passive: true });

  /* Phone bar: appears once the add button has scrolled away; tapping it brings the form back. */
  var bar = document.querySelector('[data-d9-bar]');
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var off = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', off); bar.setAttribute('aria-hidden', off ? 'false' : 'true');
      bar.querySelector('button').tabIndex = off ? 0 : -1;
    }).observe(add);
    bar.querySelector('button').addEventListener('click', function () {
      if (store() && state.day) { form.requestSubmit ? form.requestSubmit() : add.click(); return; }
      form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      say(store() ? 'Choose a pickup day.' : 'Choose the dän you’ll pick up from.', true);
    });
  }

  var v0 = variant();
  track({ event: 'view_item', ecommerce: { currency: (window.DAN39_PRODUCT || {}).currency, value: v0.price / 100, items: [{ item_id: v0.sku, item_name: (window.DAN39_PRODUCT || {}).title, price: v0.price / 100 }] } });
  var k0 = store(); if (k0) check(k0, day(0).iso);
  render();
  setInterval(render, 60000);
})();
